import { makeStyles } from '@material-ui/core';
import logo from '../../assets/logos/footballco-logo-white.svg';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 24,
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return <img className={classes.img} src={logo} alt="Footballco" />;
};
